/**
 * coordinate example:
 *
 * from: [
 *  "113.54086971865576", // lng (经度)
 *  "22.197486389830942", // lat (纬度)
 * ]
 *
 * ref: https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
 */

 export const distance = (from, to) => {
  const deg2rad = deg => deg * (Math.PI / 180);

  const lat1 = from[1];
  const lat2 = to[1];

  const lon1 = from[0];
  const lon2 = to[0];

  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1);  // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

export const distanceFromSightToPoi = (sight, poi) => {
  let _distance = null;
  // sight.coordinate may be an array of coordinates
  if (Array.isArray(sight.coordinate[0])) {
    // poi.coordinate may also be an array of coordinates
    if (Array.isArray(poi.coordinate[0])) {
      const ds = poi.coordinate.map(poiCoordinate => {
        return sight.coordinate.reduce((min, sightCoordinate) => {
          const d = Math.round(distance(sightCoordinate, poiCoordinate) * 1000);
          return min === null ? d : Math.min(min, d);
        }, null);
      })
      const idx = indexOfSmallest(ds);
      poi._nearestCoordinate = poi.coordinate[idx]; // save this nearest coordinate for poi marker creation
      _distance = ds[idx];
    } else {
      _distance = sight.coordinate.reduce((min, sightCoordinate) => {
        const d = Math.round(distance(sightCoordinate, poi.coordinate) * 1000);
        return min === null ? d : Math.min(min, d);
      }, null);
    }
  } else {
    if (Array.isArray(poi.coordinate[0])) {
      const ds = poi.coordinate.map(poiCoordinate => {
        return Math.round(distance(sight.coordinate, poiCoordinate) * 1000);
      });
      const idx = indexOfSmallest(ds);
      poi._nearestCoordinate = poi.coordinate[idx]; // save this nearest coordinate for poi marker creation
      _distance = ds[idx];
    } else {
      _distance = Math.round(distance(sight.coordinate, poi.coordinate) * 1000);
    }
  }
  return _distance;
}

function indexOfSmallest(arr) {
  let idx = 0;
  for (let i = 1; i < arr.length; i++) {
   if (arr[i] < arr[idx]) idx = i;
  }
  return idx;
}
